export default __webpack_public_path__ + "static/media/purchasegrn.0b232a8d.svg";